export default class ConsoleService {

	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return (this._instance = new ConsoleService());
	}

	setConsole(console) {
		this.console = console;
	}

	getUsers() {
		return this.console.getUsers();
	}

	getRoles() {
		return this.console.getRoles();
	}

	isAdmin() {
		return this.console.isAdmin();
	}

	currentUser() {
		return this.console.user;
	}

	refreshToken() {
		return this.console.refreshToken();
	}

	logout() {
		this.console.logout();
	}

	login() {
		this.console.login();
	}

	toggleSidenav() {
		this.console.toggleSidenav();
	}

	getExpanded() {
		return this.console.getExpanded();
	}

	getDomainConfig() {
		return this.console.getDomainConfig();
	}

	maybeExpandSidenav() {
		if (!this.console) {
			return false;
		}
		if (!this.getExpanded()) {
			this.toggleSidenav();
		}
		this.hideShowBtns(true);
		return true;
	}

	maybeCollapseSidenav() {
		if (!this.console) {
			return false;
		}
		if (this.getExpanded()) {
			this.toggleSidenav();
		}
		this.hideShowBtns(false);
		return true;
	}

	hideShowBtns(showBtns) {
		this.console.hideShowBtns(showBtns);
	}

	customLogin(username, password) {
		return this.console.createToken(username, password)
			.then(() => this.console.initUser())
			.then(() => this.console.requestUpdate());
	}

	ssoLogin(base64Data) {
		const newLocal = Buffer.from(base64Data, 'base64').toString();
		this.console.updateTokensData(JSON.parse(newLocal));
	}

	initUser() {
		return this.console.initUser();
	}

	getTokenDetails() {
		return this.console.getTokenDetails();
	}

}
